import { canIUse, xenv, setShare } from '@didi/webx-js'
export function setShareConfig(config) {
    const {
      share_title = '分享中间页标题',
      poster_title = '拉起海报标题',
      poster_sub_title = '拉起海报副标题',
      poster_url,
      path,
      title = '滴滴火车票', // 微信小程序卡片-图片
      img_url, // 微信小程序卡片-图片
      card_content = '分享小程序标题', // 微信小程序卡片-标题
      icon = "https://dpubstatic.udache.com/static/dpubimg/tcKG0FHbcxaXqSGjHzjnG.png", // H5-小图标
      timeline_share_type = 'text',
      timeline_share_link = ''
    } = config || {}
    const option = {
      title,
      img_url, // 微信小程序卡片-图片
      card_content, // 微信小程序卡片-标题
      icon, // H5-小图标
      poster_url,
      channels: {
        wx_appmsg: [
          // 分享给微信好友
          {
            xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
            share_type: 'miniApp', // 分享类型
            appid: 'gh_7a5c4141778f', // 分享出的小程序AppId
            miniprogram_type: 0,
            path,
          }
        ],
        wx_timeline: [
          // 分享到微信朋友圈
          {
            xenv: timeline_share_type === 'text' ? 'passenger' : xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
            share_type: timeline_share_type, // 分享类型
            link: timeline_share_link
          }
        ]
        // ... 如在channels中依次增加channel 则在拉起的面板中对应增加分享Item
      },
      mpShareConfig: {
        share_title,
        poster_title,
        poster_sub_title,
        share_imgUrl: img_url,
        share_shareImgUrl: img_url,
        share_share_group_btn_text: '分享好友'
      },
    //   activity_id,
    }
    canIUse('setShare') && setShare(option)
  }